module.exports = __webpack_public_path__ + "static/media/objectManager.96584be3.png";